exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2QobU25W0YSZIQ1RQeIEMp {\n  font-size: 0.75em;\n}", ""]);

// exports
exports.locals = {
	"s": "_2QobU25W0YSZIQ1RQeIEMp"
};